import { Flex, Modal, Span } from '@fareye/ui'
import { startCase } from '@fareye/utils'
import React from 'react'
import { PoiDetailContainer } from '../../../style/styled'
import FieldValue from './FieldValue'

function PoiDetails({ poiDetails, close }: any) {
  const {
    eta,
    name,
    icon,
    poiType,
    exitDatetime,
    enterDatetime,
    tripRunningStatus
  } = poiDetails || {}
  const PoiType = () => (
    <Flex alignItemsCenter>
      {icon}
      <Span style={{ marginLeft: 5 }}>{startCase(poiType)}</Span>
    </Flex>
  )
  let status
  if (tripRunningStatus) {
    status = `Early by ${tripRunningStatus.duration}`
    if (tripRunningStatus.status === '-') {
      status = `Delay by ${tripRunningStatus.duration}`
    }
  }
  return poiDetails ? (
    <Modal
      toggleModal={poiDetails}
      setToggleModal={() => close()}
      variant="xxs"
      style={{
        backdrop: { background: 'transparent' },
        content: {
          maxHeight: '300px',
          maxWidth: 250,
          boxShadow: '0 0 20px 1px rgba(0,0,0,.2)'
        }
      }}
    >
      <PoiDetailContainer>
        <Span variant="h5" style={{ marginBottom: 15 }}>
          {name}
        </Span>
        <FieldValue
          style={{ marginBottom: 15 }}
          labelStyle={{ color: '#343434', fontWeight: 500 }}
          label="Poi Type"
          value={<PoiType />}
        />
        <FieldValue
          style={{ marginBottom: 15 }}
          labelStyle={{ color: '#343434', fontWeight: 500 }}
          label="E.T.A.: "
          value={eta}
        />
        <FieldValue
          style={{ marginBottom: 15 }}
          labelStyle={{ color: '#343434', fontWeight: 500 }}
          label="In: "
          value={enterDatetime}
        />
        <FieldValue
          style={{ marginBottom: 15 }}
          labelStyle={{ color: '#343434', fontWeight: 500 }}
          label="Out: "
          value={exitDatetime}
        />
        <FieldValue
          style={{ marginBottom: 15 }}
          labelStyle={{ color: '#343434', fontWeight: 500 }}
          label="Trip Running "
          value={status ? tripRunningStatus.duration : 'Unknown'}
        />
      </PoiDetailContainer>
    </Modal>
  ) : null
}

export default PoiDetails
